module.exports = __webpack_public_path__ + "images/feature/20170228-1-55c34760b248b437b20f18aa5992eec2.jpg";